export default __webpack_public_path__ + "static/homeschool-bg-903ef579ea8cfce98c7bae89e2becd16.jpg";